import lazyLoading from './lazyLoading'

export default {
  name: 'holder',
  meta: {
    expanded: false,
    title: 'Permisionario',
    iconClass: 'vuestic-icon vuestic-icon-user'
  },
  children: [
    {
      name: 'HolderDashboard',
      path: '/holder/dashboard',
      component: lazyLoading('app/holder/dashboard/Dashboard'),
      meta: {
        title: 'Dashboard'
      }
    },
    {
      name: 'HolderMonitor',
      path: '/holder/monitor',
      component: lazyLoading('monitor/google-maps/HolderGoogleMapsPage'),
      meta: {
        title: 'Monitor Permisionario'
      }
    },
    {
      name: 'pagos',
      path: '/holder/pagos',
      component: lazyLoading('app/holder/PaymentList'),
      meta: {
        title: 'Consulta Pagos',
        requiresAuth: true
      }
    },
    /*
    {
      name: 'HolderSales',
      path: '/holder/sales',
      component: lazyLoading('app/holder/Main'),
      meta: {
        title: 'Ventas'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/holder/Sales'),
          meta: {
            title: 'Ventas'
          }
        }
      ]
    },
    */
    {
      name: 'HolderDriver',
      path: '/holder-drivers',
      component: lazyLoading('app/holder/Main'),
      meta: {
        title: 'Conductores'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/holder/DriversList'),
          meta: {
            title: 'menu.drivers'
          }
        },
        {
          path: ':driverId',
          component: lazyLoading('app/holder/DriverView'),
          props: true,
          meta: {
            title: 'menu.drivers'
          }
        }
      ]
    },
    {
      name: 'Holderars',
      path: '/holder-cars',
      component: lazyLoading('app/holder/Main'),
      meta: {
        title: 'Vehículos'
      },
      children: [
        {
          path: '', // Default route
          component: lazyLoading('app/holder/CarsList'),
          meta: {
            title: 'Vehículos'
          }
        },
        {
          path: ':carId',
          component: lazyLoading('app/holder/CarView'),
          props: true,
          meta: {
            title: 'Vehículo'
          }
        }
      ]
    },
  ]
}



// WEBPACK FOOTER //
// ./src/store/modules/menu/holder.js